import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the user logs table view.
 * @extends JetView
 */
export default class tableLogsUserView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Retrieving partner ID from parameters

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 200,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Type',
                                    header: _('Tipo'), // Localized header
                                    editor: 'combo', // Combo editor for this column
                                    options: [{ id: '0', value: _('Cambio') }], // Options for the combo
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Table',
                                    header: _('Elemento'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Field',
                                    header: _('Campo'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId',
                                    header: _('ID Externo'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValuePrevius',
                                    header: _('Valor antes'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Value',
                                    header: _('Valor despues'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Reason',
                                    header: _('Razon'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserModified',
                                    header: _('Usuario Modificó'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IP',
                                    header: _('Dirección IP'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'OS',
                                    header: _('Sistema operativo'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                            ],
                            on: {
                                // Event handlers for the DataTable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math functions
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID
        grid = $$('datatable'); // Get the DataTable instance
        var url = devConfig.geturlApi() + 'null/Report/GetLogsUserGeneral?Partner=' + id_partner + '&'; // Construct the API URL
        var filter = ''; // Initialize filter string

        // Event listener for filtering logs
        this.on(this.app, 'logsUser:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date; // Handle single date
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to query
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for data requests
        grid.attachEvent('onDataRequest', function (start, count) {
            custom_load(url, start, count); // Custom load function
            return true; // Indicate that the event is handled
        });

        /**
         * Custom function to load data from the API.
         * @param {string} url - The API URL.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to fetch.
         */
        function custom_load(url, start, count) {
            grid.load(url + '?start=' + start + '&count=' + count); // Load data with pagination
        }

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
